export default "__VITE_ASSET__BpxIhptv__"